/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Consent_Settings_Granted_OnInputs */

const en_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Granted on ${i?.date}`)
};

const de_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erteilt am ${i?.date}`)
};

const fr_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accorde le ${i?.date}`)
};

const es_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Otorgado el ${i?.date}`)
};

const it_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Concesso il ${i?.date}`)
};

const nl_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verleend op ${i?.date}`)
};

const pl_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Udzielono ${i?.date}`)
};

const fi_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Myonnetty ${i?.date}`)
};

const da_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Givet den ${i?.date}`)
};

const sv_consent_settings_granted_on = /** @type {(inputs: Consent_Settings_Granted_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beviljat den ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Granted on {date}" |
*
* @param {Consent_Settings_Granted_OnInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_settings_granted_on = /** @type {((inputs: Consent_Settings_Granted_OnInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_Granted_OnInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_settings_granted_on(inputs)
	if (locale === "fr") return fr_consent_settings_granted_on(inputs)
	if (locale === "es") return es_consent_settings_granted_on(inputs)
	if (locale === "it") return it_consent_settings_granted_on(inputs)
	if (locale === "nl") return nl_consent_settings_granted_on(inputs)
	if (locale === "pl") return pl_consent_settings_granted_on(inputs)
	if (locale === "fi") return fi_consent_settings_granted_on(inputs)
	if (locale === "da") return da_consent_settings_granted_on(inputs)
	if (locale === "sv") return sv_consent_settings_granted_on(inputs)
	return en_consent_settings_granted_on(inputs)
});